module.exports = __webpack_public_path__ + "static/media/agenda.4f47889a.svg";